import { Injectable } from '@angular/core';
import { finalize, map, mergeAll, mergeMap, switchMap, tap } from 'rxjs/operators';
import { BehaviorSubject, merge } from 'rxjs';

import { ResponseModel, UserBaseModel } from '@core/api';

import * as moment from 'moment';
import { ToastService } from '@ui/toast';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { TransportService } from '@core/components/services/renter-form/transport.service';
import { RenterService } from '@core/components/services/renter-form/renter.service';
import { FullRenterForm } from '@core/components/interfaces/renter-form/full-renter-form';
import { TransportModel } from '@core/api/model/transportModel';
import { concat } from 'rxjs/internal/observable/concat';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';

@Injectable({
  providedIn: 'root'
})
export class RenterRegFormService implements FullRenterForm {

  allowedRegistration = false;

  successMessage = this.i18n('Пользователь успешно создан');

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();

  private successSubject = new BehaviorSubject<boolean>(false);
  public success$ = this.successSubject.asObservable();

  user: UserBaseModel = null;
  transport: TransportModel = null;

  constructor(
    private transportService: TransportService,
    private renterService: RenterService,
    private toastService: ToastService,
    private i18n: I18n
  ) {}

  buildForms({ renter = null, transport = null, verification = false } = {}) {
    if(renter && renter.id) {
      this.user = renter;
    }

    if(transport && transport.id) {
      this.transport = transport
    }

    this.renterService.buildForm(renter, verification);
    this.transportService.buildForm(transport);
  }

  get registrationForm() {
    return this.renterService.registration;
  }

  get renterForm() {
    return this.renterService.user;
  }

  get renterIdentificationDataForm(){
    return this.renterService.identification_data;
  }

  get renterImagesForm() {
    return this.renterService.images;
  }

  get transportForm() {
    return this.transportService.transport;
  }

  get transportImagesForm() {
    return this.transportService.images;
  }

  reset() {
    this.allowedRegistration = false;

    this.user = null;
    this.transport = null;

    this.transportService.resetForm();
    this.renterService.resetForm();
  }

  private scrollToError() {
    requestAnimationFrame(() => {
      if (document.querySelectorAll(`[class*="mat-form-field-invalid"]`).length) {
        document.querySelectorAll(`[class*="mat-form-field-invalid"]`)[0].scrollIntoView();
      }
    });
  }

  private markFormGroupTouched() {
    this.transportService.markFormGroupTouched();
    this.renterService.markFormGroupTouched();

    this.scrollToError();
  }

  submitRegistration() {
    this.loadingSubject.next(true);

    this.markFormGroupTouched();

    if (this.user) {
      this.requestUpdateUserData();
    } else {
      this.requestRegistration();
    }
  }

  requestRegistration() {
    this.renterService.requestRegUser()
      .subscribe(
        (res) => this.successRegister(res),
        () => this.loadingSubject.next(false)
      );
  }

  successRegister(res: ResponseModel<UserBaseModel>) {
    this.loadingSubject.next(false);

    if (res.success) {
      this.user = res.data;

      this.requestUpdateUserData();
    }
  }

  successUpdateData() {
    this.loadingSubject.next(false);
    this.successSubject.next(true);

    this.toastService.success({
      close: true,
      message: this.successMessage
    });

    this.reset();
  }

  requestUpdateUserData(success?: () => void) {
    this.loadingSubject.next(true);

    this.markFormGroupTouched();

    /*let transportRequest = this.transportService.requestCreateUserTransport(this.user.id)
      .pipe(tap(res => this.transport = res.data))
      .pipe(switchMap((res) => forkJoin(...this.transportService.requestUploadTransportImage(this.user.id, this.transport.id))));

    if (this.transport) {
      transportRequest = this.transportService.requestUpdateUserTransport(this.user.id, this.transport.id)
        .pipe(switchMap((res) => forkJoin(...this.transportService.requestUploadTransportImage(this.user.id, this.transport.id))));
    }*/
    return this.renterService.requestUpdateUserData(this.user.id)
      .pipe(switchMap(() => forkJoin(...this.renterService.requestsUploadUserImage(this.user.id))))
      .subscribe(
        () => {
          success && success();
          this.successUpdateData();
        }, () => {
          this.loadingSubject.next(false);
        }
      );
  }
}
